module.exports = {"firestore":{"rules":"firestore.rules","indexes":"firestore.indexes.json"},"hosting":{"public":"dist","ignore":["firebase.json","**/.*","**/node_modules/**"],"rewrites":[{"source":"**","destination":"/index.html"}]}}


//////////////////
// WEBPACK FOOTER
// ./firebase.json
// module id = 8UQN
// module chunks = 1